import React from 'react'

function ReportCardTile(props) {

    const { classes, total, completed, name } = props
    
    return (
        <div className={`tile-wrapper ${classes}`} >
            <h2 className="name">{name}</h2>
            <div className="count">
                <span className="completed">{completed}</span>
               
                {total && <span className="bal-devided">&#47;</span>}
                {total && <span className="total">{total}</span>}
                
            </div>

        </div>
    )
}
export default ReportCardTile;
